
<div class="clear"></div>
<div [ngClass]="stateId ? 'hide-me' : 'banner-img'">
  <div class="banner-text">
    <h3>Legal</h3>
    <p>Access your insurance documentation from one convinient location.</p>
  </div>
</div>
<div class="clear"></div>
<div [ngClass]="stateId ? '' : 'widget-disclosure' ">
  @if (disclosure) {
    <div class="widget-container">
      <h3 class="group-title">
        {{disclosure.sectionTitle}}
      </h3>
      @if (stateId) {
        <div>
          @if (discloserStateexist) {
            <div>
              @for (disclosureInfo of disclosure.content; track disclosureInfo) {
                <div class="fraud-disclosures">
                  @if (stateId === disclosureInfo.StateProvince) {
                    <div class="text-info">
                      <p class="title">{{disclosureInfo.title }} </p>
                      <p class="text">{{disclosureInfo.text }} </p>
                    </div>
                  }
                  @if ((disclosureInfo.StateProvince === 'NY') && (stateId === 'NY' && HNOAflag)) {
                    <div class="text-info">
                      @if (productID === 'BOP' || productID === 'GL') {
                        <div>
                          <p class="title">{{disclosureInfo.autoTitle}}</p>
                          <p class="text">{{disclosureInfo.autoText}}</p>
                        </div>
                      }
                    </div>
                  }
                  @if ((disclosureInfo.StateProvince === 'PA') && (stateId === 'PA' && HNOAflag)) {
                    <div class="text-info">
                      @if (productID === 'BOP' || productID === 'GL') {
                        <div>
                          <p class="title">{{disclosureInfo.autoTitle}}</p>
                          <p class="text">{{disclosureInfo.autoText}}</p>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          } @else {
            <div class="text-info">
              <p class="title">{{disclosurecommonTitle}}{{stateId}}:</p>
              <p class="text">{{disclosurecommonText}} </p>
            </div>
          }
        </div>
      } @else {
        <div class="disclosure-info">
          <span class="selectLabel"> Select a state: </span>
          <div [cbSelectChoice]="fraudStateSelect" label="Select State" [hideRequiredMarker]="true" styleVariant="gray-fill">
            <p-select #fraudStateSelect
              [options]="disclosure"
              optionLabel="StateProvince"
              optionValue="StateProvince"
              placeholder="Select..."
              inputId="fraudStateSelect"
              appendTo="body"
              (onChange)="displayDisclosure(getDisclosureForState($event.value))">
            </p-select>
          </div>
        </div>
        @if (disclosureTitle && disclosureText) {
          <div class="disclosure-content">
            <div class="disclosure-title">
              {{disclosureTitle}}
            </div>
            <div class="disclosure-text">
              {{disclosureText}}
            </div>
          </div>
        }
      }
    </div>
  }
</div>
<div class="clear"></div>
